export default "__VITE_ASSET__DPOMQfGn__"